module.exports = __webpack_public_path__ + "img/arrow-right.dd695a56.svg";